import connect from '../axios/axios.auth';

const empresaFunction =  {
  contrasena: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/auth/change`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  data: (data) => {
    return new Promise((resolve, reject) => {
      connect.get(`/empresa/configuracion`, { data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  extras: (data) => {
    return new Promise((resolve, reject) => {
      connect.get(`/empresa/configuracion-extra`, { data })
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  extrasUpdate: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/empresa/configuracion-extra`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  update: (data) => {
    return new Promise((resolve, reject) => {
      connect.put(`/empresa/`, { data })
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  checkSizeImage: (w, h, file) => {
    return new Promise((resolve) => {
      let height = 0;
      let width = 0;
      let img = new Image();
      img.onload = function () {
        height = img.height;
        width = img.width;
        if (width === w && height === h) {
          resolve(true);
        } else {
          resolve(false);
        }
       }
       img.src = URL.createObjectURL(file);
    })
  },
}

export default empresaFunction;